export { useQuery as usePersistQuery } from 'react-query'
